import { createMuiTheme } from "@material-ui/core/styles";

// カスタムプロパティ定義は types/app.d.ts 参照
const SSearchTheme = createMuiTheme({
  extra: {
    sidebar: {
      background: "#303146",
    },
    pageHeader: {
      background: "#F3F2F1",
    },
  },
  palette: {
    background: {
      paper: "#ffffff",
    },
    // text: {
    //   primary: "rgba(0,0,0,0.87)",
    //   secondary: "rgba(255,255,255,1.0)",
    //   disabled: "rgba(0,0,0,0.38)",
    //   hint: "rgba(0,0,0,0.38)",
    // },
    info: {
      main: "rgba(0,0,0,0.87)",
    },
    success: {
      main: "rgba(0,0,0,0.87)",
    },
  },
  typography: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    button: {
      textTransform: "none",
    },
  },
  props: {
    MuiTextField: {
      variant: "standard",
    },
    MuiCheckbox: {
      color: "primary",
    },
    MuiRadio: {
      color: "primary",
    },
    MuiSwitch: {
      color: "primary",
    },
  },
});

export default SSearchTheme;
